import {  Box, CardMedia } from '@mui/material';

import './card.css'

const ServiceCard = ({ service }) => {
  const { icon, title, description } = service;




  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <CardMedia
          sx={{
            height:"70%",
            borderRadius: "1rem",


          }}
          >

<img
          src={service.src}
          alt=""
          style={{
            width:'100%',
            height:"100%",
            overflow:'hidden',
            borderTopLeftRadius: "1rem",
  borderTopRightRadius: "1rem",


          }}
          />
          </CardMedia>
          

           <Box sx={{ fontSize: "0.9rem", color: "black", marginBottom: 2,display:'flex',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
            marginTop:'1rem',
            gap:'1'
            }}>
            <Box sx={{ fontSize: "1.5rem", color: "black", }}>
            {icon}

            </Box>
                      
                      <p
          style={{
            color:'black',
          }}
           className="title">{title}</p>
                    </Box>
         
        
        </div>
        <div className="flip-card-back">
          <p className="title">{title}</p>
          <p
          style={{
            padding:'1rem',
          }}
          >{description}</p>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
